/*
 * @Description:
 * @Author: PF
 * @Date: 2023-01-31 09:39:06
 * @LastEditors: wanglixin wang1223634360@163.com
 * @LastEditTime: 2023-05-05 11:09:56
 */

import { loadSelect } from '@/api/common.js'
// 加载字典下拉框
export function loadZiDianSelect (lx, data) {
  loadSelect({ url: '/api/v2/sys/zidian/list', parms: { lx: lx }, data: data, order: 'sx', sort: 'asc' }) // [url]接口地址 [lx]字典类别 [data]列表
}

export function erJiZiDianSelect (lx, data) {
  loadSelect({ url: '/api/v2/sys/zidian/tree', parms: { lx: lx }, data: data, order: 'sx', sort: 'asc' }) // [url]接口地址 [lx]字典类别 [data]列表
}
